// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"SubstantialContributionPage_subtitle__1NKYa","radioGroup":"SubstantialContributionPage_radioGroup__3hTx3","nextStepBtn":"SubstantialContributionPage_nextStepBtn__2HdbW"};